import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/blog/components/BlogArticle.tsx");
